import { Cell, Row, Skeleton } from '@vizit/atoms';
import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from '@vizit/feature-flags';
import { cx } from '@vizit/theme';
import * as React from 'react';
import { rowClasses } from './product-listing-row.classes';

interface ProductListingRowLoadingProps {
  /**
   * Whether to show the action column
   * @default false
   */
  showActionColumn?: boolean;
}

const ProductListingRowLoading = React.memo((props: ProductListingRowLoadingProps) => {
  const { showActionColumn = false } = props;
  const isRetailerEnabled = useFeatureFlag(FEATURE_FLAGS.RETAILER, false);

  return (
    <Row className={cx(rowClasses({ disabled: true }))} aria-label="Loading product row">
      <Cell className="py-8 px-12 w-full">
        <div className="flex items-center gap-6">
          {/* Image */}
          <div className="flex-shrink-0 w-40 h-40">
            <Skeleton className="w-full h-full" variant="square" />
          </div>
          <div className="flex flex-col justify-center gap-1 min-w-0 w-full">
            <Skeleton className="h-12 w-1/2" variant="square" />
            <Skeleton className="h-10 w-47" variant="square" />
          </div>
        </div>
      </Cell>
      {isRetailerEnabled && (
        <Cell className="py-8 px-12 w-60">
          <div className="flex items-center justify-center">
            <Skeleton className="h-16 w-16" variant="square" />
          </div>
        </Cell>
      )}
      <Cell className="py-8 px-12 w-60">
        <div className="flex items-center justify-center">
          <Skeleton className="h-12 w-16" variant="square" />
        </div>
      </Cell>
      <Cell className="py-8 px-12 w-60">
        <div className="flex items-center justify-center">
          <Skeleton className="h-12 w-16" variant="square" />
        </div>
      </Cell>
      <Cell className="py-8 px-12">
        <div className="flex items-center justify-start">
          <Skeleton className="h-12 w-16" variant="square" />
        </div>
      </Cell>
      {showActionColumn && (
        <Cell className="py-8 px-4">
          <div className="w-56" />
        </Cell>
      )}
    </Row>
  );
});

export { ProductListingRowLoading };
export type { ProductListingRowLoadingProps };
